import React from "react";

function ArrowDownIcon() {
  return (
    
 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_6582_8992)">
      <path d="M10.0001 10.9766L14.1251 6.85156L15.3034 8.0299L10.0001 13.3332L4.69678 8.0299L5.87511 6.85156L10.0001 10.9766Z" fill="#0E0E0E"/>
    </g>
    <defs>
      <clipPath id="clip0_6582_8992">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
}

export default ArrowDownIcon;